import Converter from "persian-date-converter";

export const MiladiToShamsi = (date) => {
  if (date) {
    const _date = new Converter();
    const generatedDate = _date?.convert(date, "fa");
    return generatedDate;
  }
};

export const ShamsiToMiladi = (date) => {
  if (date) {
    const _date = new Converter();
    return _date?.convert(date, "en");
  }
};
